"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var react_datepicker_1 = require("react-datepicker");
require("react-toastify/dist/ReactToastify.css");
var react_toastify_1 = require("react-toastify");
require("react-datepicker/dist/react-datepicker.css");
var model_1 = require("../../model");
var Button_1 = require("../_shared/components/Button");
var actions_1 = require("../_shared/weekDays/actions");
var PortalPage_1 = require("../_shared/components/PortalPage");
var layout_1 = require("../_shared/components/layout");
require("./styles.scss");
var table_1 = require("./table");
var ApproveModal_1 = require("../_shared/components/approveModal/ApproveModal");
var ClosedOrderModal_1 = require("../_shared/components/closedOrderModal/ClosedOrderModal");
var utils_1 = require("../../helpers/utils");
var constants_1 = require("../../constants");
var LoginActions_1 = require("../_shared/reducers/loginState/LoginActions");
var LoginReducer_1 = require("../_shared/reducers/loginState/LoginReducer");
// Persist UI table/filter settings locally for hours overview
var LS_HC_SETTINGS_KEY = 'hourControlTableSettings';
var readLocalHCSettings = function () {
    try {
        var raw = localStorage.getItem(LS_HC_SETTINGS_KEY);
        return raw ? JSON.parse(raw) : null;
    }
    catch (_a) {
        return null;
    }
};
var writeLocalHCSettings = function (patch) {
    try {
        var current = readLocalHCSettings() || {};
        var next = __assign(__assign({}, current), patch);
        localStorage.setItem(LS_HC_SETTINGS_KEY, JSON.stringify(next));
    }
    catch (_a) {
        // no-op: localStorage might be unavailable
    }
};
var VIEW_USERS = 'Bekijk';
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page(props) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        _this = _super.call(this, props) || this;
        _this.onSaveButtonClick = function () {
            _this.setState({ mode: ApproveModal_1.MODE_APPROVE });
            var openDays = (0, utils_1.getOpenDays)(_this.props.weekDays, _this.state.acceptUsers);
            if (openDays.length) {
                _this.approveModal && _this.approveModal.openModal();
            }
            else {
                _this.approveWeekDays();
            }
        };
        _this.isSaveButtonDisabled = function () {
            return _this.state.acceptUsers.length === 0;
        };
        _this.onControlButtonClick = function () {
            _this.setState({ mode: ApproveModal_1.MODE_CONTROL });
            var openDays = (0, utils_1.getOpenDays)(_this.props.weekDays, _this.state.controlUsers);
            if (openDays.length) {
                _this.approveModal && _this.approveModal.openModal();
            }
            else {
                _this.controlWeekDays();
            }
        };
        _this.isControlButtonDisabled = function () {
            return _this.state.controlUsers.length === 0;
        };
        var date = moment().add('-1', 'week').startOf('isoWeek');
        if (!_.isEmpty(props.weekDays) && props.weekDays[0].workDays.length > 0) {
            date = moment(props.weekDays[0].workDays[0].date).startOf('isoWeek');
        }
        var hcTableSettings = ((_b = (_a = props.identity) === null || _a === void 0 ? void 0 : _a.tableSettings) === null || _b === void 0 ? void 0 : _b.hourControlTable) || null;
        var localSettings = readLocalHCSettings();
        _this.state = {
            date: date,
            viewUsers: [],
            acceptUsers: [],
            controlUsers: [],
            userStatus: (_d = (_c = localSettings === null || localSettings === void 0 ? void 0 : localSettings.userStatus) !== null && _c !== void 0 ? _c : hcTableSettings === null || hcTableSettings === void 0 ? void 0 : hcTableSettings.userStatus) !== null && _d !== void 0 ? _d : 'all',
            userRole: (_f = (_e = localSettings === null || localSettings === void 0 ? void 0 : localSettings.userRole) !== null && _e !== void 0 ? _e : hcTableSettings === null || hcTableSettings === void 0 ? void 0 : hcTableSettings.userRole) !== null && _f !== void 0 ? _f : 'all',
            weekDayStatus: (_h = (_g = localSettings === null || localSettings === void 0 ? void 0 : localSettings.workStatus) !== null && _g !== void 0 ? _g : hcTableSettings === null || hcTableSettings === void 0 ? void 0 : hcTableSettings.workStatus) !== null && _h !== void 0 ? _h : 'all',
            approveStatus: (_k = (_j = localSettings === null || localSettings === void 0 ? void 0 : localSettings.approveStatus) !== null && _j !== void 0 ? _j : hcTableSettings === null || hcTableSettings === void 0 ? void 0 : hcTableSettings.approveStatus) !== null && _k !== void 0 ? _k : 'all',
            controlStatus: (_m = (_l = localSettings === null || localSettings === void 0 ? void 0 : localSettings.controlStatus) !== null && _l !== void 0 ? _l : hcTableSettings === null || hcTableSettings === void 0 ? void 0 : hcTableSettings.controlStatus) !== null && _m !== void 0 ? _m : 'all',
            mode: ApproveModal_1.MODE_APPROVE
        };
        return _this;
    }
    Page.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.hasClosedOrders && this.props.hasClosedOrders !== prevProps.hasClosedOrders) {
            this.closedOrderModal && this.closedOrderModal.openModal(this.state.mode);
        }
    };
    Page.prototype.selectUsers = function (index, userIds) {
        switch (index) {
            case 'controlUsers':
                this.setState({ controlUsers: userIds });
                break;
            case 'acceptUsers':
                this.setState({ acceptUsers: userIds });
                break;
            case 'viewUsers':
                this.setState({ viewUsers: userIds });
                break;
            default: break;
        }
    };
    Page.prototype.changeWeek = function (date) {
        var _this = this;
        if (date.week() !== this.state.date.week()) {
            this.setState({ date: date.startOf('isoWeek'), viewUsers: [], acceptUsers: [], controlUsers: [] }, function () {
                (0, LoginReducer_1.saveTableSettings)(_this.props, 'hourControlTable', { week: _this.state.date });
            });
        }
    };
    Page.prototype.changeUserStatus = function (userStatus) {
        var _this = this;
        this.setState({ userStatus: userStatus, weekDayStatus: 'all' }, function () {
            writeLocalHCSettings({ userStatus: _this.state.userStatus, workStatus: 'all' });
        });
    };
    Page.prototype.changeUserRole = function (userRole) {
        var _this = this;
        this.setState({ userRole: userRole }, function () {
            writeLocalHCSettings({ userRole: _this.state.userRole });
        });
    };
    Page.prototype.changeWorkStatus = function (weekDayStatus) {
        var _this = this;
        this.setState({ weekDayStatus: weekDayStatus }, function () {
            writeLocalHCSettings({ workStatus: _this.state.weekDayStatus });
        });
    };
    Page.prototype.changeControlStatus = function (controlStatus) {
        var _this = this;
        this.setState({ controlStatus: controlStatus }, function () {
            writeLocalHCSettings({ controlStatus: _this.state.controlStatus });
        });
    };
    Page.prototype.changeApproveStatus = function (approveStatus) {
        var _this = this;
        this.setState({ approveStatus: approveStatus }, function () {
            writeLocalHCSettings({ approveStatus: _this.state.approveStatus });
        });
    };
    Page.prototype.navigateWorkLogList = function () {
        var _a = this.state, viewUsers = _a.viewUsers, date = _a.date;
        this.props.setSelectedUsers(viewUsers);
        this.props.history.push('hour-control-list/' + viewUsers.join(',') + '/' + date.format('YYYY-MM-DD'));
    };
    Page.prototype.approveWeekDays = function (ignoreClosedOrders) {
        var date = this.state.date.format('YYYY-MM-DD');
        this.props.approveWeekDays(date, this.state.acceptUsers, this.props.requestDate, ignoreClosedOrders);
    };
    Page.prototype.controlWeekDays = function (ignoreClosedOrders) {
        var date = this.state.date.format('YYYY-MM-DD');
        this.props.controlWeekDays(date, this.state.controlUsers, this.props.requestDate, ignoreClosedOrders);
    };
    Page.prototype.render = function () {
        var _this = this;
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_HOURS, id: "week-overview", isLoading: this.props.isLoadingWeeklyWorkDays || this.props.isControlling || this.props.isApproving },
            React.createElement(ApproveModal_1.default, { ref: function (ref) { return _this.approveModal = ref; }, onControl: function () { return _this.controlWeekDays(); }, onApprove: function () { return _this.approveWeekDays(); }, mode: this.state.mode }),
            React.createElement(ClosedOrderModal_1.default, { orders: this.props.closedOrders, ref: function (ref) { return _this.closedOrderModal = ref; }, onControl: function () { return _this.controlWeekDays(true); }, onApprove: function () { return _this.approveWeekDays(true); } }),
            React.createElement(layout_1.Wrapper, null,
                React.createElement("div", { className: "fullWidth fix-height-top" },
                    React.createElement(layout_1.Row, null,
                        React.createElement("label", { htmlFor: "weekNumber" }, "Selecteer Week: "),
                        React.createElement(layout_1.Margin, { margin: "8px" }),
                        React.createElement(react_datepicker_1.default, { selected: moment(this.state.date).startOf('isoWeek').toDate(), onChange: function (date) { return _this.changeWeek(moment(date)); }, dateFormat: "wo", name: "weekNumber", locale: constants_1.DEFAULT_LANGUAGE }),
                        React.createElement(layout_1.Margin, { margin: "32px" }),
                        React.createElement("label", { htmlFor: "users" }, "Keur goed: "),
                        React.createElement(layout_1.Margin, { margin: "8px" }),
                        React.createElement("select", { name: "users", value: this.state.approveStatus, onChange: function (e) { return _this.changeApproveStatus(e.target.value); } },
                            React.createElement("option", { value: "all" }, "Alles"),
                            React.createElement("option", { value: "approved" }, "Ja"),
                            React.createElement("option", { value: "not-approved" }, "Nee")),
                        React.createElement(layout_1.Margin, { margin: "32px" }),
                        React.createElement("label", { htmlFor: "users" }, "Controleren: "),
                        React.createElement(layout_1.Margin, { margin: "8px" }),
                        React.createElement("select", { name: "users", value: this.state.controlStatus, onChange: function (e) { return _this.changeControlStatus(e.target.value); } },
                            React.createElement("option", { value: "all" }, "Alles"),
                            React.createElement("option", { value: "controlled" }, "Ja"),
                            React.createElement("option", { value: "not-controlled" }, "Nee")),
                        React.createElement(layout_1.Margin, { margin: "32px" }),
                        React.createElement("label", { htmlFor: "users" }, "Selecteer User Status: "),
                        React.createElement(layout_1.Margin, { margin: "8px" }),
                        React.createElement("select", { name: "users", value: this.state.userStatus, onChange: function (e) { return _this.changeUserStatus(e.target.value); } },
                            React.createElement("option", { value: "all" }, "Alles"),
                            React.createElement("option", { value: "active" }, "Active"),
                            React.createElement("option", { value: "inactive" }, "Inactive")),
                        React.createElement(layout_1.Margin, { margin: "32px" }),
                        React.createElement("label", { htmlFor: "userRole" }, "Selecteer Rol: "),
                        React.createElement(layout_1.Margin, { margin: "8px" }),
                        React.createElement("select", { name: "userRole", value: this.state.userRole, onChange: function (e) { return _this.changeUserRole(e.target.value); } },
                            React.createElement("option", { value: "all" }, "Alles"),
                            React.createElement("option", { value: "roofer" }, "Dakdekkers"),
                            React.createElement("option", { value: "mechanic" }, "Monteurs")),
                        React.createElement(layout_1.Margin, { margin: "32px" }),
                        React.createElement("label", { htmlFor: "users" }, "Selecteer Werk Status: "),
                        React.createElement(layout_1.Margin, { margin: "8px" }),
                        React.createElement("select", { name: "weekdays", value: this.state.weekDayStatus, onChange: function (e) { return _this.changeWorkStatus(e.target.value); } },
                            React.createElement("option", { value: "all" }, "All"),
                            React.createElement("option", { value: "active" }, "Active"),
                            React.createElement("option", { value: "inactive" }, "Inactive")))),
                React.createElement("div", { className: "week-hours-table" },
                    React.createElement(table_1.default, { defaultPageIndex: this.props.pageIndex, defaultPageSize: this.props.pageSize, weekDays: this.props.weekDays, weekNumber: this.state.date.week(), onSelectUsers: function (index, userIds) { return _this.selectUsers(index, userIds); }, date: this.state.date, pages: this.props.pages, userStatus: this.state.userStatus, userRole: this.state.userRole, weekDayStatus: this.state.weekDayStatus, approveStatus: this.state.approveStatus, controlStatus: this.state.controlStatus, onPageSizeChangeCallback: function (pageSize) { return writeLocalHCSettings({ pageSize: pageSize }); }, getWeeklyWorkDays: function (date, page, pageSize, filtered, sorted, userStatus, weekDayStatus, approveStatus, controlStatus, userRole) {
                            return _this.props.getWeeklyWorkDays(date, page, pageSize, filtered, sorted, userStatus, weekDayStatus, approveStatus, controlStatus, userRole);
                        } })),
                React.createElement(layout_1.Wrapper, { paddingVertical: "24px", className: 'table-actions' },
                    React.createElement(layout_1.Row, null,
                        React.createElement("span", { className: 'button' + ' ' + (this.state.viewUsers.length ? '' : 'button-disabled'), onClick: function () { return _this.state.viewUsers.length > 0 && _this.navigateWorkLogList(); } }, VIEW_USERS),
                        React.createElement(layout_1.Margin, { marginHorizontal: "24px" }),
                        React.createElement(Button_1.default, { onClick: function () { return !_this.isControlButtonDisabled() && _this.onControlButtonClick(); }, disabled: this.isControlButtonDisabled(), text: "Controleren" }),
                        (0, model_1.userHasPermission)(this.props.identity, model_1.Permission.SAVE_HOURS) && (React.createElement(React.Fragment, null,
                            React.createElement(layout_1.Margin, { marginHorizontal: "24px" }),
                            React.createElement(Button_1.default, { onClick: function () { return !_this.isSaveButtonDisabled() && _this.onSaveButtonClick(); }, disabled: this.isSaveButtonDisabled(), text: "Keur Goed" })))))),
            React.createElement(react_toastify_1.ToastContainer, null)));
    };
    return Page;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        isLoadingWeeklyWorkDays: reducer.WeekDaysReducer.isLoadingWeeklyWorkDays,
        isApproving: reducer.WeekDaysReducer.isApproving,
        isControlling: reducer.WeekDaysReducer.isControlling,
        weekDays: reducer.WeekDaysReducer.weekDays,
        pages: reducer.WeekDaysReducer.pages,
        requestDate: reducer.WeekDaysReducer.requestDate,
        identity: reducer.authentication.user,
        pageSize: reducer.WeekDaysReducer.pageSize,
        pageIndex: reducer.WeekDaysReducer.pageIndex,
        closedOrders: reducer.WeekDaysReducer.closedOrders,
        hasClosedOrders: reducer.WeekDaysReducer.hasClosedOrders,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    getWeeklyWorkDays: function (date, page, pageSize, filtered, sorted, userStatus, weekDayStatus, approveStatus, controlStatus, userRole) {
        return actions_1.Actions.getWeeklyWorkDays(date, page, pageSize, filtered, sorted, [], userStatus, weekDayStatus, approveStatus, controlStatus, userRole)(dispatch);
    },
    approveWeekDays: function (date, userIds, requestDate, ignoreClosedOrders) {
        return actions_1.Actions.approveWeekDays(date, userIds, requestDate, ignoreClosedOrders)(dispatch);
    },
    controlWeekDays: function (date, userIds, requestDate, ignoreClosedOrders) {
        return actions_1.Actions.controlWeekDays(date, userIds, requestDate, ignoreClosedOrders)(dispatch);
    },
    setSelectedUsers: function (userIds) { return actions_1.Actions.setSelectedUsers(userIds)(dispatch); },
    updateTableSettings: function (id, user) { return LoginActions_1.LoginActions.updateProfile(id, user)(dispatch); },
}); };
var HoursOverViewPage = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Page);
exports.default = HoursOverViewPage;
